const SessionSpaceCalculator = require('@/lib/Sessions/SessionSpaceCalculator');

class SessionSpaceCalculatorFactory {
    /**
     * @param {CartService} cartService
     */
    constructor(cartService) {
        /**
         * @type {CartService}
         */
        this.cartService = cartService;
    }

    /**
     * @returns {SessionSpaceCalculator}
     */
    create() {
        return new SessionSpaceCalculator(
            this.cartService.currentCart,
            this.cartService.currentCart.originalOrder
        );
    }
}

module.exports = SessionSpaceCalculatorFactory;
